// extracted by mini-css-extract-plugin
module.exports = {"headerTimer":"bookTool_headerTimer__2Ii3P"};